import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-load-error": "",
  class: "text-sm text-red-600"
}
const _hoisted_2 = {
  key: 0,
  "data-save-error": "",
  class: "mb-6 text-sm text-red-600"
}
const _hoisted_3 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_4 = { class: "w-28" }
const _hoisted_5 = { class: "mt-3 space-y-1 text-sm text-gray-500" }
const _hoisted_6 = {
  key: 0,
  "data-notice-example": ""
}
const _hoisted_7 = {
  key: 1,
  "data-upcoming-note": ""
}
const _hoisted_8 = { class: "flex" }

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import AmountField from '@/components/neue/wizard/AmountField.vue'
import SaveBar from '@/components/SaveBar.vue'
import { LEAD_TIME_UNITS, useCateringDeliverySettings } from '@/composables/useCateringDeliverySettings'
import { useUnsavedChanges } from '@/composables/useUnsavedChanges'
import { currencySymbolFor } from '@/config/sellingCountries'
import { noticeExample, upcomingDatesNote } from '@/helpers/orderNotice'

import SettingsShell from './SettingsShell.vue'


export default {
  __name: 'SettingsOrderingDelivery',
  setup(__props) {

const store = useStore()
const loading = ref(true)
const loadError = ref('')
const saveError = ref('')
const { form, upcomingDeliveryDates, load, save: persist } = useCateringDeliverySettings()
const { hasUnsavedChanges, reload } = useUnsavedChanges([form])

const currencySymbol = computed(() => currencySymbolFor(store.state.loggedInUser?.attributes?.currency))
const example = computed(() => noticeExample(form.lead_time_amount, form.lead_time_unit))
const upcomingNote = computed(() => upcomingDatesNote(upcomingDeliveryDates.value))

const serverError = (error, fallback) => error?.response?.data?.errors?.[0] || fallback

const discard = () => {
  saveError.value = ''
  return reload([load()]).catch(error => {
    saveError.value = serverError(error, "Couldn't reload your saved settings. Please try again.")
  })
}

const save = () => {
  saveError.value = ''
  return reload([persist()]).catch(error => {
    saveError.value = serverError(error, 'Unable to save right now. Please try again.')
  })
}

onMounted(() =>
  reload([load()])
    .catch(error => {
      loadError.value = serverError(
        error,
        "Couldn't load your ordering and delivery settings. Please refresh the page."
      )
    })
    .finally(() => {
      loading.value = false
    })
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    savebar: _withCtx(() => [
      _createVNode(SaveBar, {
        "has-unsaved-changes": _unref(hasUnsavedChanges),
        onOnDiscard: discard,
        onOnSave: save
      }, null, 8, ["has-unsaved-changes"])
    ]),
    default: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          (loadError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(loadError.value), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (saveError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(saveError.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(SettingsSection, {
                  title: "Order notice",
                  description: "How far ahead customers must order. Orders for a delivery close this long before it starts."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(AmountField, {
                        modelValue: _unref(form).lead_time_amount,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(form).lead_time_amount) = $event)),
                        kind: "integer",
                        name: "Notice"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(SelectInput, {
                          modelValue: _unref(form).lead_time_unit,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(form).lead_time_unit) = $event)),
                          options: _unref(LEAD_TIME_UNITS),
                          "aria-label": "Notice in"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "pb-2 text-sm text-gray-600" }, "before each delivery", -1))
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (example.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(example.value), 1))
                        : _createCommentVNode("", true),
                      (upcomingNote.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(upcomingNote.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Delivery fee",
                  description: "What customers pay for delivery on each order. Leave it blank for free delivery."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(AmountField, {
                        modelValue: _unref(form).delivery_fee_cents,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(form).delivery_fee_cents) = $event)),
                        kind: "money",
                        name: "Fee",
                        prefix: currencySymbol.value,
                        suffix: "per order"
                      }, null, 8, ["modelValue", "prefix"])
                    ])
                  ]),
                  _: 1
                })
              ], 64))
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}